export default "__VITE_ASSET__CEenPKGS__";